<template>
  <div
    :class="`fixed top-0 left-0 z-50 flex h-screen w-screen items-center justify-center bg-surface-inverse/50 light-theme laptop:pl-64 ${frameClass}`"
    data-testid="confirm-modal-overlay"
    @click.self="clickOutside"
  >
    <div :class="`relative inline-block max-h-[100%] overflow-y-auto rounded-sm bg-surface ${wrapperClass}`">
      <SvgIcon
        v-if="showFloatingCloseButton"
        :path="mdiClose"
        class="absolute top-4 right-4 cursor-pointer text-main"
        :size="24"
        data-testid="confirm-modal-close"
        @click.stop="emit('closeDialog', false)"
      />
      <slot name="title">
        <p v-if="title" class="mb-0 p-6 pr-12 txt-headline-3xl-bold">{{ title }}</p>
      </slot>
      <slot name="description">
        <p v-if="description" class="px-6 text-main/60">{{ description }}</p>
      </slot>
      <slot v-if="hasContent" name="content"> </slot>
      <slot v-if="!hideActions" name="actions">
        <div class="mt-6 flex justify-end px-6 pb-6">
          <button v-if="showCancel" class="btn-secondary-color-s" data-testid="confirm-modal-cancel" @click="emit('closeDialog', false)">
            {{ cancel || t('cancel') }}
          </button>
          <button
            v-if="showApprove"
            :disabled="disabled"
            class="btn-primary-color-s ml-4"
            data-testid="accept-button"
            @click="emit('closeDialog', true)"
          >
            {{ approve || t('approve') }}
          </button>
        </div>
      </slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { mdiClose } from '@mdi/js'
import { onMounted, onUnmounted, useSlots, computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const slots = useSlots()

const hasContent = computed(() => {
  return !!slots['content']
})

const props = withDefaults(
  defineProps<{
    approve?: string
    cancel?: string
    description?: string
    frameClass?: string
    hideActions?: boolean
    persist?: boolean
    showApprove?: boolean
    showCancel?: boolean
    title?: string
    wrapperClass?: string
    disabled?: boolean
    showFloatingCloseButton?: boolean
  }>(),
  {
    approve: undefined,
    cancel: undefined,
    description: undefined,
    frameClass: undefined,
    hideActions: undefined,
    persist: undefined,
    showApprove: true,
    showCancel: true,
    title: undefined,
    wrapperClass: undefined,
    disabled: false,
    showFloatingCloseButton: true,
  },
)

const emit = defineEmits<{
  (e: 'closeDialog', value: boolean): void
}>()

function clickOutside() {
  if (!props.persist) emit('closeDialog', false)
}

onMounted(() => {
  document.documentElement.classList.add('overflow-y-hidden')
})

onUnmounted(() => {
  document.documentElement.classList.remove('overflow-y-hidden')
})
</script>
